
import { TableCell, TableRow } from "@mui/material";
import ModalEdit from './ModalEdit';
import { useSelector } from 'react-redux';
import FileOpen from '../Dashboard/FileOpen';
import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';


const TableRowE = props => {

    const rowsPerPage = props.rPerPage;
    const page = props.pge;
    const filteredData = props.filteredData;
    const type = useSelector(state => state.type.typeIs);


    if (type === "plan"){
      return (
        (rowsPerPage > 0
               ? filteredData.reverse().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
               : filteredData.reverse()
                ).map((row) => (
              <TableRow key={row.id}>
              <TableCell component="th" scope="row">
                {row.id}
              </TableCell>
              <TableCell >
                {row.descripcion}
              </TableCell>
              <TableCell >
                {row.fecha}
              </TableCell>
              <TableCell >
                {row.creador}
              </TableCell>
              <TableCell >
                {row.creado}
              </TableCell>
              <TableCell >
                {row.modificador}
              </TableCell>
              <TableCell >
                {row.modificado}
              </TableCell>
              <TableCell >
              <FormControlLabel
                control={<Checkbox
                  name='checkbox'
                  color="primary"
                  checked={row.activo}
                  />}
                label=""
                disabled={true}
              />
              </TableCell>
              <TableCell >
              <ModalEdit data={row} />
              </TableCell>
              <TableCell>
              <FileOpen data={row}/>
              </TableCell>
            </TableRow>
             ))   
          )        
    }
    if(type === "news") {
      return (
        (rowsPerPage > 0
        ? filteredData.reverse().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : filteredData.reverse()
         ).map((row) => (
       <TableRow key={row.id}>
       <TableCell component="th" scope="row">
         {row.id}
       </TableCell>
       <TableCell >
         {row.titulo.slice(0,20)}
       </TableCell>
       <TableCell >
         {row.contenido.slice(0,60)}
       </TableCell>
       <TableCell >
         {row.creado}
       </TableCell>
       <TableCell >
         {row.creador}
       </TableCell>
       <TableCell >
         {row.modificador}
       </TableCell>
       <TableCell >
         {row.modificado}
       </TableCell>
       <TableCell >
       <FormControlLabel
          control={<Checkbox
            name='checkbox'
            color="primary"
            checked={row.activo}
            />}
          label=""
          disabled={true}
        />
       </TableCell>
       <TableCell >
       <ModalEdit data={row}/>
       </TableCell>
       <TableCell>
       <FileOpen data={row}/>
       </TableCell>
     </TableRow>
     ))    
      )  
        
  }
}

export default TableRowE;